<template>
    <div>
        <Bold :Editor="Editor"></Bold>
        <InlineCode :Editor="Editor"></InlineCode>
        <Italic :Editor="Editor"></Italic>
        <OrderedList :Editor="Editor"></OrderedList>
        <UnorderedList :Editor="Editor"></UnorderedList>
        <LinkToggleButton :Editor="Editor"></LinkToggleButton>
        <H1Button :Editor="Editor"></H1Button>
        <H2Button :Editor="Editor"></H2Button>
        <H3Button :Editor="Editor"></H3Button>
        <H4Button :Editor="Editor"></H4Button>
        <H5Button :Editor="Editor"></H5Button>
        <H6Button :Editor="Editor"></H6Button>
        <div style="min-width:12px; width:12px; display:inline-block; border-left:1px solid gray;"></div>
        <ImageButton :Editor="Editor"></ImageButton>
        <AddTable :Editor="Editor"></AddTable>
        <CodeView :Editor="Editor"></CodeView>
    </div>
</template>

<script>

import Bold from '@/views/components/atoms/tiptap/Predefined/Buttons/Bold.vue';
import InlineCode from '@/views/components/atoms/tiptap/Predefined/Buttons/InlineCode.vue';
import Italic from '@/views/components/atoms/tiptap/Predefined/Buttons/Italic.vue';
import OrderedList from '@/views/components/atoms/tiptap/Predefined/Buttons/OrderedList.vue';
import UnorderedList from '@/views/components/atoms/tiptap/Predefined/Buttons/UnorderedList.vue';

import H1Button from '@/views/components/atoms/tiptap/Predefined/Buttons/H1Button.vue';
import H2Button from '@/views/components/atoms/tiptap/Predefined/Buttons/H2Button.vue';
import H3Button from '@/views/components/atoms/tiptap/Predefined/Buttons/H3Button.vue';
import H4Button from '@/views/components/atoms/tiptap/Predefined/Buttons/H4Button.vue';
import H5Button from '@/views/components/atoms/tiptap/Predefined/Buttons/H5Button.vue';
import H6Button from '@/views/components/atoms/tiptap/Predefined/Buttons/H6Button.vue';

import AddTable from '@/views/components/atoms/tiptap/Predefined/Buttons/AddTable.vue';

import ImageButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ImageButton.vue';
import LinkToggleButton from '@/views/components/atoms/tiptap/Predefined/Buttons/LinkToggleButton.vue';

import CodeView from '@/views/components/atoms/tiptap/Predefined/Buttons/CodeView.vue';

export default ({
    components: {
        Bold,
        InlineCode,
        Italic,
        OrderedList,
        UnorderedList,
        H1Button,
        H2Button,
        H3Button,
        H4Button,
        H5Button,
        H6Button,
        AddTable,
        CodeView,
        ImageButton,
        LinkToggleButton
    },
    props: ["Editor"]
});
</script>